import { STAFF_NAMESPACE } from 'www/modules/Schedule/constants'

type AppointmentTypeStaffOption = {
  staff_appointment_type?: string | null
}

/**
 * @description
 * Производит вывод типа записи под расписанием, в случае если пользователь - staff.
 *
 * @param opts.coverNode - контейнер, который должен содержать узел для вывода информации о типе записи
 * @param opts.option - данные выбранной специальности(для страниц с расписанием и выбора специальности)
 */

const setAppointmentTypeStaff = ({
  coverNode,
  option,
}: {
  coverNode: HTMLElement | null | undefined
  option?: AppointmentTypeStaffOption | null
}): void => {
  if (!coverNode) {
    return
  }

  const appTypeStaffElement = coverNode.querySelector<HTMLElement>(`.${STAFF_NAMESPACE.appointmentType}`)

  if (!appTypeStaffElement) {
    return
  }

  const appTypeStaffInner = appTypeStaffElement.querySelector<HTMLElement>(`.${STAFF_NAMESPACE.appointmentTypeInner}`)

  if (option?.staff_appointment_type) {
    appTypeStaffElement.hidden = false

    if (appTypeStaffInner) {
      appTypeStaffInner.innerHTML = option.staff_appointment_type
    }
  } else {
    appTypeStaffElement.hidden = true
  }
}

export default setAppointmentTypeStaff
